export const InstitutionLogo = ({ logo }: { logo: string }) => {
  return (
    <img
      src={`data:image/png;base64, ${logo}`}
      className="h-6 w-6 rounded-full"
    />
  );
};
